import React from 'react';

import styles from './NotFound.css';

const NotFound = () => (
    <div className={styles.heroContainer}>
        <label className={styles.title}>Oops!</label>
        <label className={styles.text}>No podemos encontrar la página que estás buscando.</label>
        <label className={styles.text}>Código de error: 404</label>
    </div>
)

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/not-found/NotFound.jsx